import React from "react";
import "./Services.css";

export default function Services() {
  return (
    <section className="services">
      <h2>Our Roadside Services</h2>

      <div className="service-grid">
        <div className="service-card">
          <span className="icon">🚗</span>
          <h3>Vehicle Recovery</h3>
          <p>Transport to the nearest service centre.</p>
        </div>

        <div className="service-card">
          <span className="icon">🔧</span>
          <h3>On‑Site Repair</h3>
          <p>Quick diagnostics and minor fixes on the spot.</p>
        </div>

        <div className="service-card">
          <span className="icon">🚚</span>
          <h3>Transport Services</h3>
          <p>Safe towing and onward travel options.</p>
        </div>

        <div className="service-card">
          <span className="icon">📞</span>
          <h3>24/7 Support</h3>
          <p>Always available, anywhere in the UK.</p>
        </div>
      </div>
    </section>
  );
}
